import { render, staticRenderFns } from "./UndoInitiateReversal.vue?vue&type=template&id=ba30887e&"
import script from "./UndoInitiateReversal.vue?vue&type=script&lang=js&"
export * from "./UndoInitiateReversal.vue?vue&type=script&lang=js&"
import style0 from "./UndoInitiateReversal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UndoInitiateReversal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports